import React, { forwardRef, useContext, useImperativeHandle, useState } from "react";
import './SliderNote.scss';
import useSlider from "../../../shared/components/Slider/useSlider";
import { Button, Column, DateTimePicker, Label, Row, TextField } from "../../../components";
import * as  lables from "../../../shared/util/label";
import Logger from "../../../shared/services/Logger";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../shared/store";
import { useConfirmationModalContext } from "../../../shared/components/ModalConfirmationContext";
import { cleareTabsInputs, SliderDataAction, updateSliderCurrentTab, updateSliderData } from "../CustomerSliderContext";
import { CustomerNotesConstant } from "../../../shared/util/constant";
import CustomerNoteService from "../../customer-notes/CustomerNoteService";
import CustomerSliderContainerService from "../CustomerSliderContainerService";
import SliderNoteService from "./SliderNoteService";
import { AppEvenType, notifyAppEvent } from "../../../shared/store/component-notification/ComponentNotification";
import { AbilityContext } from "../../../shared/abilities/AbilityContext";
import * as constant from '../../../shared/util/constant';
import { FloatingLabel, Form, InputGroup } from "react-bootstrap";

export interface ISliderNote {
    customerId? : string
}

// methods exposed to parent
export interface SliderNoteHandles {
    save: () => Promise<boolean>;
}

const SliderNoteInner: React.ForwardRefRenderFunction<SliderNoteHandles, ISliderNote> = (props, ref) => {
    const customerNoteService = new CustomerNoteService();
    const customerSliderContainerService = new CustomerSliderContainerService();
    const sliderNoteServcice = new SliderNoteService();
    const dispatch = useDispatch();
    const slider = useSlider();
    const modalContext = useConfirmationModalContext();
    const ability = useContext(AbilityContext);
    const isUserPermitToCreateNotes = ability.can('create', "Customer Memo",constant.CustomerScreenName.CUSTOMER_NOTES)
    
    let customerInfo = useSelector((state: RootState) => state?.customerSlice);
    let customerSliderState = useSelector((state: RootState) => state?.CustomerSliderState);

    const customerNote = customerSliderState.notePage.customerNote;
    const formValidation = customerSliderState.notePage.formValidation;

    const onEntityFieldChange = (propName: string, value: string | Date|boolean) => {
        let updatedNoteData = {
            ...customerNote,
            [propName]: value,
          };
        dispatch(updateSliderData({ type : SliderDataAction.NoteUpdate, data : updatedNoteData}));
    }

    const onCancelClick = async () => {
        dispatch(cleareTabsInputs());
    }

    const onSaveClick = async () => {
        try {
            let validationError = customerNoteService.validateNote(customerNote);
            dispatch(updateSliderData({ type : SliderDataAction.NoteFormValidationUpdate, data : validationError}));
            if (Object.keys(validationError).length > 0) {
                toast.warn(CustomerNotesConstant.FORM_VALIDATION_ERROR_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT
                });
                return false;
            }

            let noteRequest = sliderNoteServcice.getCustomerNoteRequest(customerNote, customerInfo.customer.id);
            let newNote = await customerNoteService.createNote(noteRequest);
            if (newNote && newNote.id) {
                toast.success(CustomerNotesConstant.MEMO_SUCCESS_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT
                });
        
                dispatch(notifyAppEvent({ eventType : AppEvenType.NewCustomerNoteCreated, eventData : newNote}));
                dispatch(cleareTabsInputs());
                dispatch(updateSliderCurrentTab(constant.CustomerScreenTabs.notes.key));
                return true;
            }
            else {
                toast.error(CustomerNotesConstant.NOTE_UPDATE_ERROR);
                return false;
            }

            return true;
        }
        catch (ex) {
            toast.error(CustomerNotesConstant.NOTE_UPDATE_ERROR);
            Logger.logError(CustomerNotesConstant.NOTE_UPDATE_ERROR, ex);
            return false;
        }
    }

     // Expose save() to parent via ref
    useImperativeHandle(ref, () => ({
        save: async () => {
           return await onSaveClick();
        }
    }), [customerNote, customerInfo]);
    
    const mainContent = <>
        <Row>
            <Column lg={12} md={12} className="">
                <span className="sld-note-section-header">{lables.CustomerMemosLabel.NEW_MEMO}</span>
            </Column>
        </Row>
        <Row>
            <Column lg={12} md={12} className="">
            <FloatingLabel
  controlId="sldCustomerNote"
  label={
    <>
      {lables.CustomerMemosLabel.DESCRIPTION}
      <span className="text-danger">*</span>
    </>
  }
>
  <Form.Control
    as="textarea"
    name="sldCustomerNote"
    placeholder={lables.CustomerMemosLabel.DESCRIPTION}
    value={customerNote.note}
    onChange={(event) => onEntityFieldChange('note', event.currentTarget.value)}
    tabIndex={1000}
    maxLength={2000}
    isInvalid={formValidation['note']?.isValid == false}
    className='texbox-input sld-note-descr-input mb-3'
    style={{ height: '100px' }}
  />
  {formValidation['note']?.isValid == false && (
    <Form.Control.Feedback type="invalid">
      {formValidation['note']?.warningText}
    </Form.Control.Feedback>
  )}
</FloatingLabel>
            </Column>
        </Row>
        <Row>
            <Column lg={12} md={12} className="">
            <DateTimePicker
                        className="slider-notes-datepicker"
                        dateFormatCalendar="LLLL yyyy"
                        prependLabelText={lables.CustomerMemosLabel.MEMO_DATE}
                        showAppendIcon={true}
                        dropdownMode="scroll"
                        showPrependIcon={false}
                        selected={customerNote.noteDate}
                        minDate={new Date()}
                        onChange={(date) => onEntityFieldChange('noteDate', date)}
                        isInvalid={formValidation['noteDate']?.isValid == false}
                        invalidWarning={formValidation['noteDate']?.warningText}
                        invalidLableClass="lable-error sld-note-input-error"
                        isPopperTop={true}
                        tabIndex={1001}
                        >
                    </DateTimePicker>
               
            </Column>
        </Row>

          {/* Action Row */}
          <Row className="mb-2 sld-note-action-row">
            <Column lg={6} md={6} className="">
                <Button
                    className='btn btn-outline-tertiary sld-action-btn-base'
                    key="btnActivityCancel"
                    onClick={() => onCancelClick()}
                    id="btnActivityCancel"
                    color='primary'
                    outlined={true}
                    tabIndex={1002}
                >{lables.StandardSearchLable.CLEAR.toLocaleUpperCase()}
                </Button>

            </Column>
            <Column lg={6} md={6} className=" text-right">
                <Button
                    className='sld-action-btn-base'
                    key="btnActivitySave"
                    onClick={() => onSaveClick()}
                    tabIndex={1003}
                    id="btnActivitySave"
                    disabled={!isUserPermitToCreateNotes}
                    color='primary'
                >{lables.SAVE.toLocaleUpperCase()}
                </Button>
            </Column>
        </Row>
    </>

    return <div className="slider-tab-content-main-div">
       {mainContent}
    </div>;
}
const SliderNote = forwardRef(SliderNoteInner);

export default SliderNote;
export { SliderNoteInner };